export const TREETABLE_LOCALE_ZHCHT = {
    emptyMessage: 'æ«ç¡æ¸æ',
    pagination: {
        previousLabel: 'ä¸ä¸é ',
        nextLabel: 'ä¸ä¸é ',
        message: 'æ¯é  {0} æ¢è¨éï¼å± {1} æ¢è¨éã'
    }
};
